import { useMutation } from "@tanstack/react-query";
import { createJobWithoutQuoteAction } from "../actions/createJobWithOutQuote.actions";
import { sendEventSchedulerPayload } from "../../../shared/components/features/event-scheduler/actions/sendToEventScheduler.actions";

export const useCreateJobWithoutQuote = () => {
  const token = sessionStorage.getItem("token") ?? "";

  const mutation = useMutation({
    mutationFn: (payload: Record<string, any>) => createJobWithoutQuoteAction(payload, token),
  });

  return {
    createJob: mutation.mutateAsync,
    isCreating: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
};

export const useEventScheduler = () => {
  const mutation = useMutation({
    mutationFn: (payload: Record<string, any>) => sendEventSchedulerPayload(payload),
  });

  return {
    createJob: mutation.mutateAsync,
    isCreating: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
};
